<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
        <div class="bg-white p-3">
          <h5 class="card-title fw-bold mb-0">Qwilr Templates</h5>
        </div>  
      <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
        
        <div class="d-sm-flex align-items-center">
        </div>
        <div class="d-sm-flex align-items-center mt-10 mt-lg-0">
          
          <button @click="openAddQwilrTemplateBox" class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block text-decoration-none">
          Add Template
            <i class="flaticon-plus position-relative ms-5 fs-12"></i>
          </button>
        </div>
      </div>
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="table-responsive" style="overflow: visible;">
          <table class="table text-nowrap align-middle mb-0">
            <colgroup>
              <col style="width: 33%;">
              <col style="width: 33%;">
              <col style="width: 33%;">
              <col style="width: 1%;">
            </colgroup>
            <thead>
              <tr>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                  Qwilr Template Id
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                  Title
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                  Description
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="qwilrTemplate in filteredQwilrDefinitionTemplates" :key="qwilrTemplate.id">
                <th class="shadow-none title lh-1 fw-medium fs-md-15 fs-lg-16 ps-0">
                  {{ qwilrTemplate.qwilrElementId }}
                </th>
                <th class="shadow-none title lh-1 fw-medium fs-md-15 fs-lg-16 ps-0">
                  {{ qwilrTemplate.title }}
                </th>
                <th class="shadow-none title lh-1 fw-medium fs-md-15 fs-lg-16 ps-0">
                  {{ qwilrTemplate.description }}
                </th>
                
                <td class="shadow-none lh-1 fw-medium text-end pe-0">
                  <div class="dropdown">
                    <button class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <i class="flaticon-dots"></i>
                    </button>
                    <ul class="dropdown-menu">
                      <li>
                        <a
                          class="dropdown-item d-flex align-items-center"
                          href="#" @click.prevent="deleteTemplate(qwilrTemplate.id)"
                          ><i
                            class="flaticon-delete lh-1 me-8 position-relative top-1"
                          ></i>
                          Delete</a
                        >
                      </li>
                      <li>
                        <a
                          class="dropdown-item d-flex align-items-center"
                          href="#" @click.prevent="openUpdateQwilrTemplateBox(qwilrTemplate)"
                          ><i
                            class="flaticon-edit lh-1 me-8 position-relative top-1"
                          ></i>
                          Update</a
                        >
                      </li>
                      <li>
                        <a
                          class="dropdown-item d-flex align-items-center"
                          href="#" @click.prevent="goToQwilrSubstitutionMapping(qwilrTemplate.id)"
                          ><i
                            class="flaticon-settings lh-1 me-8 position-relative top-1"
                          ></i>
                          Substitution Mapping</a
                        >
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center">
          <p class="mb-0 text-paragraph">
            Showing <span class="fw-bold">{{ filteredQwilrDefinitionTemplates.length }}</span> out of
            <span class="fw-bold">{{ totalQwilrDefinitionTemplates }}</span> results
          </p>
        </div>
      </div>

      <Lightbox v-if="showAddQwilrTemplateBox" @close="closeAddQwilrTemplateBox">
        <AddQwilrDefinitionTemplate :qwilrDefinitionId="this.qwilrDefinitionId" @templateAdded="handleTemplateAdded" @close="closeAddQwilrTemplateBox"/>
      </Lightbox>
      <Lightbox v-if="showUpdateQwilrTemplateBox" @close="closeUpdateQwilrTemplateBox">
        <UpdateQwilrDefinitionTemplate :template="this.selectedBlock" @templateUpdated="handleBlockUpdated" @close="closeUpdateQwilrTemplateBox"/>
      </Lightbox>
    </div>

  </template>
  
  <script>
  import { GetQwilrDefinitionElements,DeleteQwilrDefinitionElement } from '@/core/services/entities/qwilr.service'
  import breadcrumbMixin from '@/mixins/BreadcrumbMixin'
  import Lightbox from '@/components/Common/LightboxWrapper.vue';
  import AddQwilrDefinitionTemplate from "./AddQwilrDefinitionTemplate.vue";
  import UpdateQwilrDefinitionTemplate from "./UpdateQwilrDefinitionTemplate.vue";
  import { useToast } from 'vue-toastification'
  import Swal from 'sweetalert2';

  export default {
    name: "QwilrDefinitionTemplate",
    components: {
        Lightbox,
        AddQwilrDefinitionTemplate,
        UpdateQwilrDefinitionTemplate
    },
    data() {
      return {
        searchQuery: "", 
        filteredQwilrDefinitionTemplates: [], 
        pageSize: 10, 
        pageIndex: 1, 
        totalQwilrDefinitionTemplates: 0, 
        totalPages: 1, 
        showAddQwilrTemplateBox: false,
        selectedBlock:null,
        showUpdateQwilrTemplateBox: false,
        qwilrDefinitionId:null
      };
    },
    mixins: [breadcrumbMixin],
    methods: {
      async fetchQwilrTemplatesByFilter(filter = "") {
        let isBlock=false;
        let data = await GetQwilrDefinitionElements(this.qwilrDefinitionId, isBlock);
        if(data)
        {
          this.filteredQwilrDefinitionTemplates = data.qwilrDefinitionElements;
          this.totalQwilrDefinitionTemplates = data.qwilrDefinitionElements.length;
        }

      },
      handleSearch(event) {
        event.preventDefault();
        const filter = this.searchQuery.trim();
        this.pageIndex = 1; 
        this.fetchQwilrTemplatesByFilter(filter);
      },
      changePage(page) {
        if (page > 0 && page <= this.totalPages) {
          this.pageIndex = page;
          this.fetchQwilrTemplatesByFilter(this.searchQuery);
        }
      },
      openAddQwilrTemplateBox(){
        this.showAddQwilrTemplateBox=true;
      },
      openUpdateQwilrTemplateBox(template){
        this.selectedBlock=template;
        this.showUpdateQwilrTemplateBox=true;
      },
      closeAddQwilrTemplateBox(){
        this.showAddQwilrTemplateBox=false;
      },
      closeUpdateQwilrTemplateBox(){
        this.showUpdateQwilrTemplateBox=false;
      },
      handleTemplateAdded(){
        this.fetchQwilrTemplatesByFilter("");
      },
      handleBlockUpdated(){
        this.fetchQwilrTemplatesByFilter("");
      },
      async goToQwilrSubstitutionMapping(elementId) {
        this.$router.push({ name: 'qwilrSubstitutionMappingPage', params: { id: elementId, qwilrDefinitionId:this.qwilrDefinitionId } });
      },
      async deleteTemplate(templateId) {
        const toast = useToast();

        // Show confirmation dialog using SweetAlert2
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {  
          if (result.isConfirmed) {
            try {
              const payload = { id: templateId };
              let response = await DeleteQwilrDefinitionElement(payload);  
              if (response.status === 200) {
                toast.success('Template deleted successfully!', {
                  timeout: 2000,
                });
                this.fetchQwilrTemplatesByFilter("");
              }
            } catch (ex) {
              const errorMessage = ex.response?.data || ex.message || "An unknown error occurred";
              console.log(errorMessage);
              toast.error(`Failed to delete template: ${errorMessage}`, {
                timeout: 2000,
              });
            }
          } else {
            toast.info('Template deletion canceled.', { timeout: 2000 });
          }
        });

      }
    },
    created() {
      this.qwilrDefinitionId = this.$route.params.id;
      this.fetchQwilrTemplatesByFilter("");
    }
  };
  </script>


  